module.exports = __webpack_public_path__ + "img/binding_pc_tab_03.8061a03f.png";